import * as ActionTypes from './types.action';

export const uploadInvoice = (files, fulfillmentType) => ({
  type: ActionTypes.UPLOAD_INVOICE_REQUESTED,
  files,
  fulfillmentType,
});

export const uploadInvoiceSuccess = response => ({
  type: ActionTypes.UPLOAD_INVOICE_SUCCESS,
  response,
});

export const uploadInvoiceFailure = error => ({
  type: ActionTypes.UPLOAD_INVOICE_FAILED,
  error,
});

export const uploadInvoiceReset = () => ({
  type: ActionTypes.UPLOAD_INVOICE_RESET,
});

export const fetchUploadedInvoices = (page = 0) => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_REQUESTED,
  page,
});

export const fetchUploadedInvoicesSuccess = data => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_SUCCESS,
  data,
});

export const fetchUploadedInvoicesFailure = error => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_FAILED,
  error,
});

// `silent` is used while polling for progressive results: the reducer keeps the
// existing detail in place and doesn't toggle detailLoading, so the page can
// refresh in the background without flashing a full-page spinner.
// `isAnonymous` is decided once by the caller (frozen at mount, from whether
// the visitor was logged in at the time) so a login that happens mid-poll
// doesn't switch which endpoint this id is fetched from.
// `isReferral` reads a referral signup's scan through the referral-comparison
// endpoint — that scan is the referrer's upload, not the logged-in account's.
export const fetchUploadedInvoiceDetail = (
  id,
  silent = false,
  isAnonymous = false,
  isReferral = false
) => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_REQUESTED,
  id,
  silent,
  isAnonymous,
  isReferral,
});

export const fetchUploadedInvoiceDetailSuccess = data => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_SUCCESS,
  data,
});

export const fetchUploadedInvoiceDetailFailure = error => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_FAILED,
  error,
});

// Anonymous (not-logged-in) price comparison allowance — call before showing
// the upload form so a visitor who has already used their quota sees the
// register prompt instead of picking files and then failing.
export const fetchAnonymousQuota = () => ({
  type: ActionTypes.FETCH_ANONYMOUS_QUOTA_REQUESTED,
});

export const fetchAnonymousQuotaSuccess = quota => ({
  type: ActionTypes.FETCH_ANONYMOUS_QUOTA_SUCCESS,
  quota,
});

export const fetchAnonymousQuotaFailure = error => ({
  type: ActionTypes.FETCH_ANONYMOUS_QUOTA_FAILED,
  error,
});
